import { Component } from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {AnalyticsService} from '../../../../core/services/analytics/analytics.service';

@Component({
  selector: 'app-landing-hero-banner',
  imports: [
    TranslocoPipe,
    RouterLink
  ],
  templateUrl: './landing-hero-banner.component.html',
  styleUrl: './landing-hero-banner.component.scss',
})
export class LandingHeroBannerComponent {

  constructor(
    private readonly analytics: AnalyticsService,
  ) {
  }

  public trackHeroCta(): void {
    this.analytics.clickCta('try_now', 'landing_photographer');
  }

}
